export default "__VITE_ASSET__DmkPf3eS__"